import React, {useContext, useEffect, useState } from 'react';
import Toast from '../components/helpers/Toast';
import { AuthContext } from '../context/Auth.context';
import Spinner from '../components/helpers//Spinner';
import { getVersions } from './services/versionServices';
import { isElectron } from './functions/isElectron';

const Versions = () => {

    const [versions, setVersions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [pages, setPages] = useState([]);
    const [total_current, setTotal_current] = useState(1);
    const [current_page, setCurrent_page] = useState(1);
    const [first_item, setFirst_item] = useState(1);
    const [last_item, setLast_item] = useState(1);
    const {state, CheckResponse } = useContext(AuthContext);

    const showToast = (t,d,tt) => {
        setList([...list, {
            id: Math.floor((Math.random() * 101) + 1),
            title: t,
            description: d,
            type: tt
        }]);
    }
    
    const loadVersions = () => {
        getVersions(state.auth,5,current_page).then(data => {
            CheckResponse(data);
            if(data.code == 200){
                setVersions(data.versions);
                setPages(data.pages);
                setTotal_current(data.total_current);
                setCurrent_page(data.current_page);
                setFirst_item(data.first_item);
                setLast_item(data.last_item);
            }else{
                showToast('Oops!','Algo salio mal!','danger');
            }
            setLoading(false);
          });
    }

    useEffect(() => {
        loadVersions();
    }, [current_page]);

    return (
        <>
            <Toast toastList={list}/>
            <div className="row">
                <div className="col-sm-4">
                    <h1>Versiones </h1>
                </div>
            </div>
            {!loading && <div className="row">
                <div className="col-sm-12">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th>Nombre</th>
                                <th>Descargar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {versions?.map(item => 
                                <tr key={item.id}>
                                    <td>{item.name}</td>
                                    <th>
                                       
                                        {!isElectron() &&
                                            <a target={'_blank'} href={item.link} className="btn btn-primary"  role="button">
                                                <i className="bi bi-download"></i>
                                            </a>}
                                        {isElectron() &&
                                            <a target={'_blank'} onClick={() => {window.require('electron').shell.openExternal(item.link)}}  className="btn btn-primary"  role="button">
                                                <i className="bi bi-download"></i>
                                            </a>}
                                    </th>
                                </tr>
                            )}
                            
                        </tbody>
                    </table>
                    <div className="row">
                        <div className="col-sm-12 col-md-6">
                            <ul className="pagination">
                                {pages.map(page => 
                                    <div key={page}>
                                        {current_page === page ? 
                                            <span key={page} className="page-link active me-2" style={{"width": "40px", "textAlign": "center"}}>{page}</span> 
                                            : 
                                            <li key={page} className="page-page me-2" style={{"width": "40px", "textAlign": "center"}}><a className="page-link" onClick={() => setCurrent_page(page)}>{page}</a></li>
                                        }
                                    </div>
                                )}
                            </ul>
                        </div>
                        <div className="col-sm-12 col-md-6">
                            <p className="text-sm-start mt-2">Mostrando <b>{first_item}</b> a <b>{last_item}</b> de un total de <b>{total_current}</b></p>
                        </div>
                    </div>
                </div>
            </div>}

            {loading && <Spinner size={8} margin={4} ></Spinner>}
        </>
    );
}

export default Versions;